import { createContext, useContext, useState, useCallback } from 'react';

const translations = {
  fr: {
    // Navigation
    home: 'Accueil',
    products: 'Produits',
    delivery: 'Livraison',
    about: 'À propos',
    contact: 'Contact',
    cart: 'Panier',
    
    // Hero
    heroTitle: 'Le goût authentique africain près de chez vous',
    heroSubtitle: 'Découvrez notre sélection de produits africains de qualité, livrés partout en Belgique',
    shopNow: 'Commander',
    contactUs: 'Nous contacter',
    
    // Products
    allProducts: 'Tous les produits',
    frozen: 'Surgelés',
    samosas: 'Samoussas',
    rolls: 'Rolls',
    kebabs: 'Kebabs',
    addToCart: 'Ajouter au panier',
    outOfStock: 'Rupture de stock',
    
    // Cart
    yourCart: 'Votre panier',
    emptyCart: 'Votre panier est vide',
    continueShopping: 'Continuer vos achats',
    subtotal: 'Sous-total',
    deliveryFee: 'Frais de livraison',
    total: 'Total',
    checkout: 'Passer la commande',
    remove: 'Retirer',
    
    // Checkout
    checkoutTitle: 'Finaliser la commande',
    customerInfo: 'Informations client',
    fullName: 'Nom complet',
    email: 'Email',
    phone: 'Téléphone',
    deliveryAddress: 'Adresse de livraison',
    city: 'Ville',
    postalCode: 'Code postal',
    paymentMethod: 'Méthode de paiement',
    creditCard: 'Carte bancaire (Stripe)',
    paypal: 'PayPal',
    cashOnDelivery: 'Paiement à la livraison',
    placeOrder: 'Confirmer la commande',
    processing: 'Traitement en cours...',
    
    // Delivery
    deliveryPolicy: 'Politique de livraison',
    deliveryTitle: 'Livraison partout en Belgique',
    deliveryLiege: 'Livraison à Liège',
    deliveryPeriphery: 'Périphéries de Liège',
    deliveryOutside: 'Hors Liège',
    minimumOrder: 'Commande minimum de 75€',
    
    // About
    aboutTitle: 'Qui sommes-nous ?',
    aboutWelcome: 'Bienvenue chez AfriOne B&D, votre solution simple et rapide pour accéder à l\'alimentation africaine en Belgique',
    ourMission: 'Notre mission',
    missionText: 'Rendre les produits africains accessibles à tous, avec des prix très compétitifs, une excellente qualité et une livraison rapide partout en Belgique.',
    ourObservation: 'Notre constat',
    ourSolution: 'Notre solution',
    ourGoal: 'Notre objectif',
    ourCommitment: 'Notre engagement',
    ourPromise: 'Notre promesse',
    
    // Contact
    contactTitle: 'Contactez-nous',
    contactSubtitle: 'Nous sommes à votre écoute',
    sendMessage: 'Envoyer',
    yourMessage: 'Votre message',
    address: 'Adresse',
    callUs: 'Appelez-nous',
    messageSent: 'Message envoyé avec succès !',
    
    // Success/Cancel
    orderSuccess: 'Commande confirmée !',
    orderSuccessMessage: 'Merci pour votre commande. Vous recevrez un email de confirmation.',
    orderCancelled: 'Commande annulée',
    orderCancelledMessage: 'Votre commande a été annulée. Votre panier est toujours disponible.',
    backToHome: 'Retour à l\'accueil',
    
    // Footer
    followUs: 'Suivez-nous',
    quickLinks: 'Liens rapides',
    contactInfo: 'Contact',
    rights: 'Tous droits réservés',
    
    // Misc
    added: 'Ajouté au panier',
    loading: 'Chargement...',
  },
  en: {
    // Navigation
    home: 'Home',
    products: 'Products',
    delivery: 'Delivery',
    about: 'About',
    contact: 'Contact',
    cart: 'Cart',
    
    // Hero
    heroTitle: 'Authentic African taste near you',
    heroSubtitle: 'Discover our selection of quality African products, delivered throughout Belgium',
    shopNow: 'Shop Now',
    contactUs: 'Contact Us',
    
    // Products
    allProducts: 'All Products',
    frozen: 'Frozen',
    samosas: 'Samosas',
    rolls: 'Rolls',
    kebabs: 'Kebabs',
    addToCart: 'Add to cart',
    outOfStock: 'Out of stock',
    
    // Cart
    yourCart: 'Your Cart',
    emptyCart: 'Your cart is empty',
    continueShopping: 'Continue shopping',
    subtotal: 'Subtotal',
    deliveryFee: 'Delivery fee',
    total: 'Total',
    checkout: 'Checkout',
    remove: 'Remove',
    
    // Checkout
    checkoutTitle: 'Complete your order',
    customerInfo: 'Customer Information',
    fullName: 'Full Name',
    email: 'Email',
    phone: 'Phone',
    deliveryAddress: 'Delivery Address',
    city: 'City',
    postalCode: 'Postal Code',
    paymentMethod: 'Payment Method',
    creditCard: 'Credit Card (Stripe)',
    paypal: 'PayPal',
    cashOnDelivery: 'Cash on Delivery',
    placeOrder: 'Place Order',
    processing: 'Processing...',
    
    // Delivery
    deliveryPolicy: 'Delivery Policy',
    deliveryTitle: 'Delivery throughout Belgium',
    deliveryLiege: 'Delivery in Liège',
    deliveryPeriphery: 'Liège periphery',
    deliveryOutside: 'Outside Liège',
    minimumOrder: 'Minimum order of 75€',
    
    // About
    aboutTitle: 'Who are we?',
    aboutWelcome: 'Welcome to AfriOne B&D, your simple and fast solution for accessing African food in Belgium',
    ourMission: 'Our Mission',
    missionText: 'Making African products accessible to everyone, with very competitive prices, excellent quality and fast delivery throughout Belgium.',
    ourObservation: 'Our Observation',
    ourSolution: 'Our Solution',
    ourGoal: 'Our Goal',
    ourCommitment: 'Our Commitment',
    ourPromise: 'Our Promise',
    
    // Contact
    contactTitle: 'Contact Us',
    contactSubtitle: 'We are here to help',
    sendMessage: 'Send',
    yourMessage: 'Your message',
    address: 'Address',
    callUs: 'Call Us',
    messageSent: 'Message sent successfully!',
    
    // Success/Cancel
    orderSuccess: 'Order Confirmed!',
    orderSuccessMessage: 'Thank you for your order. You will receive a confirmation email.',
    orderCancelled: 'Order Cancelled',
    orderCancelledMessage: 'Your order has been cancelled. Your cart is still available.',
    backToHome: 'Back to Home',
    
    // Footer
    followUs: 'Follow Us',
    quickLinks: 'Quick Links',
    contactInfo: 'Contact',
    rights: 'All rights reserved',
    
    // Misc
    added: 'Added to cart',
    loading: 'Loading...',
  }
};

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState('fr');
  
  const t = useCallback((key) => {
    return translations[language][key] || key;
  }, [language]);
  
  const toggleLanguage = useCallback(() => {
    setLanguage(prev => prev === 'fr' ? 'en' : 'fr');
  }, []);
  
  const getLocalizedField = useCallback((item, field) => {
    const langField = `${field}_${language}`;
    return item[langField] || item[field] || '';
  }, [language]);
  
  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t, getLocalizedField }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}
